import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const StoreInfoList = styled.ul`
  list-style-position: inside;
`;

export const StoreInfoText = styled.li(
  props => css`
    &:last-of-type {
      margin-bottom: ${layout.measurements.spacing100};
    }

    color: ${props.theme.text.secondary};
  `
);

export const StoreInfoTextInner = styled.span``;
